var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shopping-list"}},[_c('v-container',[_c('v-row',{staticClass:"justify-center align-center"},[_c('h1',[_vm._v("Create your own shopping list")])]),_c('createlist')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }